export default __webpack_public_path__ + "media/icons/shop-icon-1b351470.svg";